import script from "./BillingDetailShopPdf.vue?vue&type=script&lang=js"
export * from "./BillingDetailShopPdf.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__